import { throttle } from 'throttle-debounce';

export const throttleSave = (time, func) => throttle(time, func);



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Session/SessionSaveUtils.jsx